function throttle(fn, delay) {
  let lastTime = 0

  return function (this: any, ...args) {
    let now = Date.now()
    if (now - lastTime >= delay) {
      fn.apply(this, args)
      lastTime = now
    }
  }
}

export default throttle
